import { GetterTree } from 'vuex'
import { RootState } from '@/Infrastructure/Store/RootState'
import { AuctionState } from './AuctionState'
import { Offer } from './Offer'
import { SendEncryptedOfferResponseDto } from '@/Application/XmlOffer/SendEncryptedOfferResponseDto'

export const getters: GetterTree<AuctionState, RootState> = {
  lastWizardStep (state: AuctionState): number {
    return state.lastWizardStep
  },
  offers (state: AuctionState): Offer[] {
    return state.offers
  },
  resultPost (state: AuctionState): SendEncryptedOfferResponseDto {
    return state.resultPost
  }
}
